import React, { useEffect, useState } from "react";
import {
  Table,
  Tag,
  Button,
  Space,
  Card,
  Typography,
  message,
  Popconfirm,
} from "antd";
import {
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import adminService from "../../services/userApprovalService";
import toast from "react-hot-toast";
import DeleteUserModal from "../../components/UserApproval/DeleteUserModal";
const { Title, Text } = Typography;

const AdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(false);
  const [update, setUpdate] = useState(false);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const res = await adminService.getAllUsers();
      setUsers(res);
    } catch {
      message.error("Failed to fetch users");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();

    if (update) {
      setUpdate(false);
    }
  }, [update]);

  const handleApprove = async (id) => {
    try {
      await adminService.approveUser(id);
      toast.success("User approved");
      setUsers(
        users.map((u) => (u._id === id ? { ...u, status: "approved" } : u))
      );
    } catch {
      toast.error("Failed to approve user");
    }
  };

  const handleDeny = async (id) => {
    try {
      await adminService.denyUser(id);
      toast.success("User denied");
      setUsers(
        users.map((u) => (u._id === id ? { ...u, status: "denied" } : u))
      );
    } catch {
      toast.error("Failed to deny user");
    }
  };

  const handleModal = (id) => {
    setId(id);
    setOpen(true);
  };

  const columns = [
    {
      title: "Full Name",
      dataIndex: "fullName",
      key: "fullName",
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: "Business Name",
      dataIndex: "businessName",
      key: "businessName",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        const color =
          status === "approved"
            ? "green"
            : status === "denied"
            ? "red"
            : "gold";
        return <Tag color={color}>{status?.toUpperCase()}</Tag>;
      },
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          {record.status === "pending" ? (
            <>
              <Button
                type="primary"
                icon={<CheckOutlined />}
                onClick={() => handleApprove(record._id)}
              >
                Approve
              </Button>
              <Popconfirm
                title="Are you sure to deny this user?"
                onConfirm={() => handleDeny(record._id)}
                okText="Yes"
                cancelText="No"
              >
                <Button danger icon={<CloseOutlined />}>
                  Deny
                </Button>
              </Popconfirm>
            </>
          ) : (
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              onClick={() => handleModal(record._id)}
            >
              Delete
            </Button>
          )}
        </Space>
      ),
    },
  ];

  return (
    <>
      <DeleteUserModal open={open} setOpen={setOpen} id={id} setUpdate={setUpdate} />
      <div style={{ padding: 24 }}>
        <Card
          title={
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <Title level={3} style={{ marginBottom: 0 }}>
                  User Approvals
                </Title>
                <Text type="secondary">
                  Manage user registrations and approvals
                </Text>
              </div>
            </div>
          }
          bordered={false}
          style={{
            borderRadius: 10,
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
          }}
        >
          <Table
            columns={columns}
            dataSource={users}
            rowKey="_id"
            loading={loading}
            pagination={{ pageSize: 8 }}
          />
        </Card>
      </div>
    </>
  );
};

export default AdminUsers;
